
import AOS from "aos"
import "aos/dist/aos.css"
import { mapGetters } from "vuex"

export default {
  mounted() {
    AOS.init({
      once: true
    })
    const sliderIndexSwiper = new swiper.default(".slider-index .swiper", {
      modules: [swiper.Navigation, swiper.Pagination, swiper.Autoplay],
      loop: true,
      autoplayDisableOnInteraction: false,
      autoplay: true,
      slidesPerView: 1,
      autoHeight: true,
      watchSlidesProgress: true,
      scrollbar: false,
      disableOnInteraction: false,
      speed: 2000,
      autoplay: {
        delay: 3800
      },
      on: {
        sliderMove: this.sliderMove,
        slideChangeTransitionStart: this.slideChangeTransitionStart
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: "true",
        type: "bullets",
        renderBullet: function (index, className) {
          return (
            '<span class="' +
            className +
            '">' +
            '<span class="swiper-pagination-bar"></span>' +
            '<span class="swiper-pagination-progress"></span>' +
            "</span>"
          )
        }
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    })
  },
  data() {
    return {
      monthArray: [
        "января",
        "февраля",
        "марта",
        "апреля",
        "мая",
        "июня",
        "июля",
        "августа",
        "сентября",
        "октября",
        "ноября",
        "декабря"
      ],
      currentMount: new Date().getMonth()
    }
  },
  methods: {
    sliderMove() {
      document
        .querySelectorAll(".swiper-slide-next .slider-index__media")
        .forEach(val => { })
      document
        .querySelectorAll(".swiper-slide-next .slider-index__circle")
        .forEach(val => {
          val.style.display = "none"
          val.classList.remove("aos-init", "aos-animate")
          val.style.display = "block"
          val.classList.add("aos-init", "aos-animate")
        })
    }
  },
  computed: {
    ...mapGetters({
      settings: "settings/settings/settings"
    }),
    slides() {
      return [
        // {
        //   id: 5,
        //   link: "/cars?sort=price%7Casc"
        // },
        {
          id: 6,
          link: "/cars/diesel?sort=price%7Casc"
        },
        {
          id: 2,
          link: "/cars?sort=price%7Casc"
        },
        {
          id: 3,
          link: "/cars?sort=price%7Casc"
        },
        {
          id: 4,
          link: "/cars?sort=price%7Casc"
        },
      ]
    }
  }
}
